import React, { createContext, useState, SetStateAction, Dispatch, useLayoutEffect, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import Search from '../api/search'
import { useSetErrorStatus } from '../errorHandler'

type contentsErrorType = {
  contentErrorStatus: number
  setContentErrorStatus: Dispatch<SetStateAction<number>>
}

type addressType = {
  address: string
  category: 'address' | 'contract'
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
}

export const AddressTypeContext = createContext({} as addressType)
export const ContentsErrorContext = createContext({} as contentsErrorType)

type Props = {
  children: React.ReactNode
}

export const AddressTypeProvider = ({ children }: Props) => {
  const { address } = useParams() as { address: string }
  const [contentErrorStatus, setContentErrorStatus] = useState<number>(0)
  const [category, setCategory] = useState<'contract' | 'address'>('address')
  const [loading, setLoading] = useState<boolean>(true)
  const [initLoading, setInitLoading] = useState<boolean>(true)
  const setErrorStatus = useSetErrorStatus()
  const mountedRef = useRef<boolean>()

  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])
  useEffect(() => {
    if (mountedRef.current) {
      setInitLoading(true)
    }
    const fetchData = async () => {
      const { result, error } = await Search(address)
      if (mountedRef.current) {
        if (error !== null) {
          setErrorStatus(error.status)
        } else if (result.searchType === 2) {
          setCategory('address')
        } else if (result.searchType === 1) {
          setCategory('contract')
        } else {
          setErrorStatus(404)
        }
      }
    }
    fetchData().finally(() => {
      if (mountedRef.current) {
        setInitLoading(false)
      }
    })
  }, [address])

  // 페이지 이동시 이전 상태 제거
  useLayoutEffect(() => {
    setErrorStatus(0)
  }, [])

  return (
    <AddressTypeContext.Provider value={{ address, category, loading, setLoading: (value) => setLoading(value) }}>
      <ContentsErrorContext.Provider value={{ contentErrorStatus, setContentErrorStatus }}>
        {!initLoading && children}
      </ContentsErrorContext.Provider>
    </AddressTypeContext.Provider>
  )
}
